import styled from "styled-components";

export const TopRightContainer = styled.div`
  position: absolute;
  top: calc(64px + 16px);
  right: 0;
  z-index: 10;
`;
